export { default as parsers } from './parsers';
export * from './types';
export * from './validations';
export * from './WarningProvider';
export const generateFormDataFromFile = (file) => {
    const formData = new FormData();
    formData.append('files', file);
    return formData;
};
//# sourceMappingURL=index.js.map